<template>
<div style='position:relative;'>
    <v-card>

        <div :class="$style.targetSurveyEditorTools">
            <v-switch :hide-details="true" class="mx-5" v-model="widgetDeveloperMode">
                <template slot="label">
                    Developer Tool
                    <v-tooltip bottom color="black">
                        <template v-slot:activator="{on, attrs}">
                            <v-icon style="margin-left: 5px" color="black" small v-bind="attrs" v-on="on">fas
                                fa-info-circle</v-icon>
                        </template>
                        <span>
                            It is available to Developers only
                        </span>
                    </v-tooltip>
                </template>
            </v-switch>

            <v-btn small color="primary" depressed class="mx-5" @click="add_widget()">
                Add a Widget
            </v-btn>
        </div>

        <!-- Widget Trash Section -->
        <div style="text-align: right; margin: 15px 50px 0 0; padding-bottom: 30px;">

            <v-menu offset-y nudge-left='50'>
                <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        x-small
                        icon
                        color="primary"
                        dark
                        v-bind="attrs"
                        v-on="on"
                        :disabled="widget_trash.length === 0"
                        >
                        <div :class="$style.widgetTrashSection">
                            <v-badge right>
                                <template v-slot:badge>
                                    <span>{{widget_trash.length}}</span>
                                </template>
                                <svgIcon :src="trashIcon" />
                            </v-badge>
                            <span :class="$style.widgetTrashLabel">widget Trash</span>
                        </div>
                    </v-btn>
                </template>
                <v-list v-if="widget_trash.length > 0">
                    <draggable class="list-group" :list="widget_trash" group="widgets" >
                        <v-list-item v-for="(item, index) in widget_trash" :key="'trash_widget_'+index">
                            <div style="border-bottom: 1px solid lightgrey;">
                                <h3>Name: {{item.name}}</h3>
                            </div>
                        </v-list-item>
                    </draggable>
                </v-list>
            </v-menu>
        </div>
        
        <!-- Widget Section -->
        <div>
            <div :class="$style.list_container">
                <!-- Widget Draggable Section -->
                <draggable 
                    :class="[{[$style.emptyWidgetWrapper]: items.length == 0}, 'list-group']"
                    :list="items" :group="'widgets'" handle=".handle">
                    <template v-for="(widget,widget_index) in items">
                        <div :class="$style.list_item" :key="'widget_'+widget_index">
                            <aside :class="[$style.widgetItemDragSection, 'handle']">
                                <svgIcon :src="dragIcon" />
                            </aside> 

                            <main :class="$style.widgetItemMainSection">
                                <v-icon 
                                    @click="removeWidget(widget_index);"
                                    color="black" 
                                    small 
                                    :class="$style.deleteIcon">
                                    fa fa-times-circle
                                </v-icon>
                                
                                <v-expansion-panels>
                                    <v-expansion-panel class="custom-icon-rotation">
                                        <v-expansion-panel-header expand-icon="fas fa-angle-right">
                                            <span style="font-size: 1.2rem; color: black">
                                                {{widget.name}}
                                            </span>
                                        </v-expansion-panel-header>

                                        <v-expansion-panel-content :class="$style.widgetExpansionsContentSection">
                                            <div>
                                                <div style="width: 65%;">
                                                    <span>Widget Name</span>
                                                    <v-text-field v-model="widget.name" outlined dense/>

                                                    <span>
                                                        Reference QID
                                                    </span>
                                                    <v-text-field 
                                                        v-model="widget.display_target" 
                                                        outlined 
                                                        hide-details 
                                                        dense/>
                                                </div>

                                                <div v-if="widget.name" style="position: relative;">
                                                    <div v-show="widgetDeveloperMode" class='mt-2'>
                                                        <span>
                                                            Execute function on trigger = (questionMap, language, component)
                                                        </span>
                                                        <v-textarea 
                                                            outlined
                                                            v-model="widget.onTrigger"/>
                                                    </div>

                                                    <!-- Add Rule & Rule Trash Section -->
                                                    <div style="display:flex; flex-direction: row; margin-top: 15px;">
                                                        <!-- Add Rule Btn -->
                                                        <v-btn 
                                                            @click="add_rule(widget)" 
                                                            color="primary"
                                                            small
                                                            depressed
                                                            class="ml-5 mt-3">
                                                            Add Rule
                                                        </v-btn>

                                                        <!-- Rule Trash Section -->
                                                        <div style="margin: 15px 20px 0 auto;">
                                                            <v-menu offset-y nudge-left='50'>
                                                                <template v-slot:activator="{ on, attrs }">
                                                                    <v-btn
                                                                        x-small
                                                                        icon
                                                                        color="primary"
                                                                        dark
                                                                        v-bind="attrs"
                                                                        v-on="on"
                                                                        :disabled="rule_trash.length === 0"
                                                                        >
                                                                        <div :class="$style.ruleTrashSection">
                                                                            <v-badge right>
                                                                                <template v-slot:badge>
                                                                                    <span>{{rule_trash.length}}</span>
                                                                                </template>
                                                                                <svgIcon :src="trashIcon" />
                                                                            </v-badge>
                                                                            <span :class="$style.ruleTrashLabel">Rules Trash</span>
                                                                        </div>
                                                                    </v-btn>
                                                                </template>
                                                                <v-list v-if="rule_trash.length > 0">
                                                                    <draggable class="list-group" :list="rule_trash" :group="'rules'" >
                                                                        <v-list-item v-for="(item, index) in rule_trash" :key="'trash_widget_' + widget_index + 'rules_'+index">
                                                                            <div style="border-bottom: 1px solid lightgrey;">
                                                                                <h3>Name: {{item.name}}</h3>
                                                                            </div>
                                                                        </v-list-item>
                                                                    </draggable>
                                                                </v-list>
                                                            </v-menu>
                                                        </div>
                                                    </div>


                                                    <draggable 
                                                        :class="[{[$style.emptyWidgetRulesWrapper]: widget.rules.length == 0}, 'list-group']"
                                                        :list="widget.rules" 
                                                        :group="'rules'" 
                                                        handle=".handle">
                                                        <template v-for="(rule,rule_index) in widget.rules">

                                                            <div :key="'widget_'+widget_index+'_rule_'+rule_index" :class="$style.list_item">

                                                                <!-- Widget Rule Draggable Icon -->
                                                                <aside :class="[$style.widgetRuleItemDragSection, 'handle']">
                                                                    <svgIcon :src="dragIcon" />
                                                                </aside>

                                                                <main :class="$style.widgetRuleItemMainSection">
                                                                    <v-icon 
                                                                        @click="removeWidgetRule(widget_index, rule_index);"
                                                                        color="black" 
                                                                        small 
                                                                        :class="$style.deleteIcon">
                                                                        fa fa-times-circle
                                                                    </v-icon>

                                                                    <v-expansion-panels>
                                                                        <v-expansion-panel class="custom-icon-rotation">
                                                                            <v-expansion-panel-header expand-icon="fas fa-angle-right" style="background-color: lightgrey;">
                                                                                <span style="font-size: 1.2rem; color: black;">
                                                                                    {{rule.name}}
                                                                                </span>
                                                                            </v-expansion-panel-header>

                                                                            <v-expansion-panel-content :class="$style.widgetRuleExpansionContentSection">
                                                                                <div>
                                                                                    <!-- Rule Name Input -->
                                                                                    <span>
                                                                                        Rule Name <i>(ANY rule will trigger question display)</i>
                                                                                    </span>
                                                                                    <v-text-field 
                                                                                        v-model="rule.name" 
                                                                                        hide-details
                                                                                        outlined
                                                                                        dense
                                                                                        background-color="white" />
                                                                                    
                                                                                    <div v-if="rule.name" style="psotion: relative;">
                                                                                        <!-- widget's Rule's Condition Add Btn + its Trash -->
                                                                                        <div style="display: flex;">
                                                                                            <v-btn 
                                                                                                small
                                                                                                depressed
                                                                                                @click="add_condition(rule)"
                                                                                                class='my-3'
                                                                                                color="primary">
                                                                                                Add Condition
                                                                                            </v-btn>
                                                                                            <div style="margin: 15px 20px 0 auto;">
                                                                                                <v-menu offset-y nudge-left='50'>
                                                                                                    <template v-slot:activator="{ on, attrs }">
                                                                                                        <v-btn
                                                                                                            x-small
                                                                                                            icon
                                                                                                            color="primary"
                                                                                                            dark
                                                                                                            v-bind="attrs"
                                                                                                            v-on="on"
                                                                                                            :disabled="condition_trash.length === 0"
                                                                                                            >
                                                                                                            <div :class="$style.conditionTrashSection">
                                                                                                                <v-badge right>
                                                                                                                    <template v-slot:badge>
                                                                                                                        <span>{{condition_trash.length}}</span>
                                                                                                                    </template>
                                                                                                                    <svgIcon :src="trashIcon" />
                                                                                                                </v-badge>
                                                                                                                <span :class="$style.conditionTrashLabel">Condition Trash</span>
                                                                                                            </div>
                                                                                                        </v-btn>
                                                                                                    </template>
                                                                                                    <v-list v-if="condition_trash.length > 0">
                                                                                                        <draggable class="list-group" 
                                                                                                            :list="condition_trash" 
                                                                                                            :group="'condition'" >
                                                                                                            <v-list-item 
                                                                                                                v-for="(item, index) in condition_trash" 
                                                                                                                :key="'trash_widget_' + widget_index + 'rules_'+rule_index + 'condition_' + index">
                                                                                                                <div style="border-bottom: 1px solid lightgrey;">
                                                                                                                    <h3>Condition #{{index + 1}}: {{item.name}}</h3>
                                                                                                                </div>
                                                                                                            </v-list-item>
                                                                                                        </draggable>
                                                                                                    </v-list>
                                                                                                </v-menu>
                                                                                            </div>
                                                                                        </div>
                                                                                        <!-- widget's Rule's Conditon Draggable Section -->
                                                                                        <draggable 
                                                                                            :class="[{[$style.emptyWidgetRulesConditionWrapper]: rule.conditions.length == 0}, 'list-group']"
                                                                                            :list="rule.conditions"
                                                                                            :group="'condition'" 
                                                                                            handle=".handle">
                                                                                            <template
                                                                                                v-for="(condition, condition_index) in rule.conditions">
                                                                                                <div :key="'widget_'+widget_index+'_rule_'+rule_index+'_condition_'+condition_index"
                                                                                                    :class="[$style.list_item]">
                                                                                                    
                                                                                                    <!-- widget's Rule's Conditon Draggable Icon -->
                                                                                                    <aside :class="[$style.widgetRuleConditionDragSection, 'handle']">
                                                                                                        <svgIcon :src="dragIcon" />
                                                                                                    </aside>

                                                                                                    <!-- widget's Rule's Conditon Draggable Expansion Panels -->
                                                                                                    <main :class="$style.widgetRuleConditionMainSection">
                                                                                                        <v-icon 
                                                                                                            @click="removeWidgetRuleCondition(widget_index, rule_index, condition_index);"
                                                                                                            color="black" 
                                                                                                            small 
                                                                                                            :class="$style.deleteIcon">
                                                                                                            fa fa-times-circle
                                                                                                        </v-icon>
                                                                                                        <v-expansion-panels>
                                                                                                            <v-expansion-panel class="custom-icon-rotation">
                                                                                                                <v-expansion-panel-header expand-icon="fas fa-angle-right">
                                                                                                                    <span>
                                                                                                                        Condition: #{{condition_index + 1}} 
                                                                                                                        <i>(ALL conditions required to trigger rule)</i>
                                                                                                                    </span>
                                                                                                                </v-expansion-panel-header>

                                                                                                                <v-expansion-panel-content :class="$style.widgetRuleConditionExpansionContentSection">
                                                                                                                    <div style="width: 50%" >

                                                                                                                        <!-- Condition Name Input -->
                                                                                                                        <span>Condition Name</span>
                                                                                                                        <v-text-field
                                                                                                                            v-model="condition.name"
                                                                                                                            outlined
                                                                                                                            dense
                                                                                                                            />

                                                                                                                        <!-- Condition Reference Source input -->
                                                                                                                        <span>
                                                                                                                            Reference Source
                                                                                                                            <v-tooltip right color="black"> 
                                                                                                                                <template v-slot:activator="{on, attrs}">
                                                                                                                                    <v-icon style="margin-left: 5px" 
                                                                                                                                        color="black"
                                                                                                                                        small 
                                                                                                                                        v-bind="attrs" 
                                                                                                                                        v-on="on">fas fa-info-circle</v-icon>
                                                                                                                                </template>
                                                                                                                                <span>
                                                                                                                                    Reference source is the question that relates to the rule or condition mentioned.
                                                                                                                                </span>
                                                                                                                            </v-tooltip>
                                                                                                                        </span>
                                                                                                                        <v-select
                                                                                                                            outlined
                                                                                                                            dense
                                                                                                                            :items="list_types"
                                                                                                                            v-model='condition.ref_type' />
                                                                                                                    
                                                                                                                        <!-- Condition Question Selection - v-if: ref_type = question -->
                                                                                                                        <template
                                                                                                                            v-if="condition.ref_type=='question'">
                                                                                                                            <v-switch
                                                                                                                                v-model="condition.clear_on_close"
                                                                                                                                label="Clear on close" />
                                                                                                                            
                                                                                                                            <span>Question Selection</span>
                                                                                                                            <v-select
                                                                                                                                :items="list_questions"
                                                                                                                                outlined
                                                                                                                                v-model='condition.ref_id'
                                                                                                                                label="Question" />

                                                                                                                            
                                                                                                                            <template v-if="condition.ref_id!=null">
                                                                                                                                <span>Group Selection</span>
                                                                                                                                <v-select                                                                                                                                
                                                                                                                                    outlined
                                                                                                                                    :items="list_group(condition.ref_id)"
                                                                                                                                    v-model="condition.group_id"
                                                                                                                                    label="Group" />
                                                                                                                            </template>

                                                                                                                            <template v-if="condition.ref_id!=null && condition.group_id!=null">
                                                                                                                                <span>Has Selected?</span>
                                                                                                                                <v-select
                                                                                                                                    v-if="condition.ref_id!=null && condition.group_id!=null"
                                                                                                                                    outlined
                                                                                                                                    :items="list_input(condition.ref_id, condition.group_id)"
                                                                                                                                    v-model="condition.input_id"
                                                                                                                                    label="Has selected" />
                                                                                                                            </template>
                                                                                                                            
                                                                                                                            <template v-if="condition.ref_id!=null && condition.group_id!=null && condition.input_id==null">
                                                                                                                                <span>Contains - list selections in: []</span>
                                                                                                                                <v-text-field                                                                                                                                   
                                                                                                                                    type="text"
                                                                                                                                    v-model="condition.contains"
                                                                                                                                    outlined
                                                                                                                                    />
                                                                                                                                </template>

                                                                                                                            <span>Advanced: Function Wrapper (question, questionMap, language) - remember to consider null values</span>
                                                                                                                            <v-textarea
                                                                                                                                outlined                                                                                                                                    
                                                                                                                                v-model="condition.advanced" />

                                                                                                                            <span>Watcher: Function Wrapper (question, questionMap, language, self) - remember to consider null values</span>
                                                                                                                                <v-textarea 
                                                                                                                                outlined 
                                                                                                                                v-model="condition.watcher"/>
                                                                                                                        </template>
                                                                                                                    </div>
                                                                                                                </v-expansion-panel-content>
                                                                                                            </v-expansion-panel>
                                                                                                        </v-expansion-panels>
                                                                                                    </main>
                                                                                                </div>
                                                                                            </template>
                                                                                        </draggable>
                                                                                    </div>
                                                                                </div>
                                                                            </v-expansion-panel-content>
                                                                        </v-expansion-panel>
                                                                    </v-expansion-panels>
                                                                </main>
                                                            </div>
                                                        </template>
                                                    </draggable>
                                                </div>
                                            </div>
                                        </v-expansion-panel-content>
                                    </v-expansion-panel>
                                </v-expansion-panels>
                            </main>
                        </div>
                    </template>
                </draggable>
            </div>
        </div>

    </v-card>
</div>
</template>

<script>
import draggable from "vuedraggable";
import edit_label from "./edit_labels.vue";

import svgIcon from '@/components/svg/svg_icon.vue';
import dragIcon from '@/assets/images/icons/drag.svg';
import trashIcon from '@/assets/images/icons/trash.svg';

export default {
    name: 'widget-editor',
    props: {
        widgets: {
            type: Array,
            required: true
        },
        languages: {
            type: Array,
            required: true
        },
        questions: {
            type: Array,
            required: true
        },
        questionMap: {
            type: Object,
            required: true
        },
        developerMode: {
            type: Boolean,
            required: true
        }
    },
    components: {
        draggable,
        edit_label,
        svgIcon
    },
    created: function(){
        this.items = this.$root.unlink(this.widgets);
    },
    data: function(){
        return {
            items: null,
            widget_trash: [],
            rule_trash: [],
            condition_trash: []
        }
    },
    methods: {
        add_widget: function(){
            this.items.push(
                {
                    name: null,
                    display_target: null,
                    onTrigger: null,
                    rules: []
                }
            );
        },
        add_rule: function(widget){
            widget.rules.push({
                name: null,                
                conditions: []
            })
        },
        add_condition: function(rule){
            rule.conditions.push({
                name: null,
                ref_type: 'question',
                ref_id: null,
                group_id: null,
                input_id: null,
                contains: null,
                equals: null,
                clear_on_close: true,
                advanced: null,
                watcher: null
            })
        },
        
        list_group: function(question_id){
            var question = this.questionMap[question_id];

            var list = [];
            for(let g=0; g<question.config.groups.length; g++){
                var group = question.config.groups[g];
                list.push({
                    text: 'Index: ' +group.id+ (group.label.en ? ' - '+group.label.en : ''),
                    value: group.id
                })
            }
            return list;
        },
        list_input: function(question_id, group_id){
            var question = this.questionMap[question_id];

            for(let g=0; g<question.config.groups.length; g++){
                var group = question.config.groups[g];
                if(group.id == group_id){
                    break;
                }
            }

            var inputs = group.inputs;

            var list = [];

            for(let i=0; i<inputs.length; i++){
                var input = inputs[i];
                list.push({
                    text: input.label.en,
                    value: input.id
                })
            }
            return list;
        },
        removeWidget: function(widget_index) {
            this.widget_trash.push(this.items[widget_index]);
            this.items.splice(widget_index, 1);
        },
        removeWidgetRule: function(widget_index, rule_index) {
            this.rule_trash.push(this.items[widget_index].rules[rule_index]);
            this.items[widget_index].rules.splice(rule_index, 1);
        },
        removeWidgetRuleCondition: function(widget_index, rule_index, condition_index){
            this.condition_trash.push(this.items[widget_index].rules[rule_index].conditions[condition_index]);
            this.items[widget_index].rules[rule_index].conditions.splice(condition_index, 1);
        },
    },
    computed: {
        list_types: function(){
            return [
                {
                    text: 'question',
                    value: 'question'
                },
                {
                    text: 'context',
                    value: 'context'
                }
            ]
        },
        list_questions: function(){
            var questions = [];
            for(let i=0; i<this.questions.length; i++){
                var question = this.questions[i];
                questions.push({
                    text: "ID: "+question.config.id+" "+question.config.body.en,
                    value: question.config.id
                })
            }

            return questions
        },
        widgetDeveloperMode: {
            get: function () {
                return this.developerMode;
            },
            set: function (newValue) {
                this.$emit('updatedDeveloperMode', newValue);
            }
        },
        dragIcon: function () {
            return dragIcon;
        },
        trashIcon: function () {
            return trashIcon;
        }
    },
    watch: {
        items: {
            deep: true,
            handler: function(){
                this.$emit('update',{
                    widgets: this.items
                })
            }
        }
    }
}
</script>

<style module>
.targetSurveyEditorTools {
    display: flex;
    flex-direction: row;
    align-items: flex-end;
    justify-content: flex-end;
    padding: 20px 0;
}

.list_container{
    width: 98%;
    margin: 0 auto;
    padding-bottom: 15px;
}

.list_item{
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    position: relative;
    margin: 15px 0px 15px 0px;
    background-color: inherit;
}


.widgetItemDragSection, .widgetRuleItemDragSection, .widgetRuleConditionDragSection {
    cursor: grab;
    display: flex;
    flex-direction: column;
    text-align: center;
    width: 4.5%;
    background-color: #eeeeee;
    cursor: grab;
    justify-content: center;
}

.widgetRuleItemDragSection, .widgetRuleConditionDragSection {
    height: 65px;
}

.widgetItemDragSection {
    height: 50px
}

.widgetItemDragSection:active, .widgetRuleItemDragSection:active, .widgetRuleConditionDragSection:active {
    cursor: grabbing;
}

.widgetItemDragSection span, .widgetRuleItemDragSection span, .widgetRuleConditionDragSection span {
    font-size: 10px;
    color: #82B1FF;
}

.widgetItemMainSection, .widgetRuleItemMainSection, .widgetRuleConditionMainSection {
    width: 95.5%;
    position: relative;
}

.widgetExpansionContentSection, .widgetRuleExpansionContentSection, .widgetRuleConditionExpansionContentSection {
    background-color: white;
    border-top: 1px solid #E5E5E5;
    padding-top: 15px;
}

.widgetRuleExpansionContentSection {
    background-color: lightgrey;
}

.targetSurveyEditorTools {
    display: flex;
    flex-direction: row;
    align-items: flex-end;
    justify-content: flex-end;
    padding: 20px 0;
}

.widgetTrashSection, .ruleTrashSection, .conditionTrashSection {
    display: flex; 
    flex-direction: column; 
    align-items: center; 
    justify-content: center;
    cursor: pointer;
}

.widgetTrashLabel, .ruleTrashLabel, .conditionTrashLabel {
    font-size: 8px; 
    color: black; 
    font-weight: 400; 
    text-transform: initial;
}
.deleteIcon {
    position: absolute; 
    top: -9px; 
    right: -5px; 
    z-index:2;
    cursor: pointer;
}

.emptyWidgetWrapper, .emptyWidgetRulesWrapper, .emptyWidgetRulesConditionWrapper{
    border: 1px dashed silver;
    height: 50px;
    margin-top: 15px;
    padding-bottom: 15px;
}

.emptyWidgetWrapper:after {
    content: 'Drag Widget to here...';
    margin: 0 auto;
    vertical-align: -50%;
    text-align: center;
    padding: 0 15px;
}

.emptyWidgetRulesWrapper:after {
    content: 'Drag Widget Rule to here...';
    margin: 0 auto;
    vertical-align: -50%;
    text-align: center;
    padding: 0 15px;
}

.emptyWidgetRulesConditionWrapper:after {
    content: 'Drag Widget Rule Condition to here...';
    margin: 0 auto;
    vertical-align: -50%;
    text-align: center;
    padding: 0 15px; 
}
</style>